import { connectWebSocket, disconnectWebSocket } from './Actions';
import { wsUrl } from './wsUrl';

// The post-login / post-logout WebSocket bounce.
//
// A session change does NOT travel over an already-open socket: the socket carries
// whatever identity it was opened with (bff/ws.py reads `account_id` once, at
// connect). So after logging in or out the socket must be torn down and reopened,
// or the page keeps acting as whoever it connected as.
//
// The 50ms gap is load-bearing: WS_DISCONNECT and an immediate WS_CONNECT would
// race, and the replaced socket's late close would land on the new one. The
// middleware guards that (review !738 #2), but the gap keeps the ordering obvious.
//
// Extracted from AuthHeader by station-anon-login-prompt (!769 review #6): the
// anonymous sign-in prompt needs the SAME bounce, and two copies of a timing-
// sensitive sequence drift apart.
export const reconnectWs = (dispatch) => {
  dispatch(disconnectWebSocket());
  setTimeout(() => dispatch(connectWebSocket(wsUrl())), 50);
};

export default reconnectWs;
